import { createAction } from "@reduxjs/toolkit";

import { ADDRESS_FORM_MODIFICATION_HANDLED, ADDRESS_FORM_MODIFIED, RESET_CART_PAGE, } from "./cartPageConstants";


export const addressFormModified = createAction(ADDRESS_FORM_MODIFIED);
export const addressFormModificationHandled = createAction(ADDRESS_FORM_MODIFICATION_HANDLED);
export const resetCartPage = createAction(RESET_CART_PAGE);
